<div class="router-transitions">
  <router-outlet></router-outlet>
</div>
